import {
	type PageRequest,
	createPageRequest,
} from '@atlassian/jira-shared-types/src/rest/jira/page.tsx';
import { ITEMS_PER_PAGE, EXPAND_PARAMETERS } from '../../model/constants.tsx';
import { NAME } from '../../model/sort-field.tsx';
import { getSortField, getSortDirection, getPage } from '../../state/selectors/query/index.tsx';
import type { State } from '../../state/types.tsx';

const SORT_FIELDS = {
	[NAME]: 'NAME',
} as const;

const getSort = (state: State) => ({
	direction: getSortDirection(state),
	field: SORT_FIELDS[getSortField(state)],
});

export const getServiceRequest = (state: State): PageRequest =>
	createPageRequest(getPage(state), ITEMS_PER_PAGE, getSort(state), EXPAND_PARAMETERS);
